export enum Messages {
  saveChanges = 'Changes have been saved.',
  passwordHasBeenChanged = 'Password has been changed.',
  commonErrorMessage = 'Something went wrong. Please try again later.',
  errorEnternet = 'No internet connection. Make sure your device is connected to the internet.',
  sessionExpiredError = 'Session expired. Please log in again.',
  emailNotRecognizedError = 'This email is not recognized.',
  retryAccountCreationSuccess = 'Your request to retry account creation has been submitted.',
  contributionsUpdated = 'The list has been successfully updated.',
  operationIsBeingProcessed = 'The operation is being processed. Please update the page in a few minutes, the imported data will be displayed.',
  successExportCsv = 'CSV file downloaded successfully.',
  successGenerateAccountStatement = 'Account statement downloaded successfully.',
}
